module.exports = __webpack_public_path__ + "img/title_contact.9e5811e6.png";